/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ItemModel = {
    readonly url?: string;
    readonly id?: string;
    readonly created_at?: string;
    readonly is_deleted?: boolean;
    readonly updated_at?: string;
    readonly guid?: string;
    deleted_at?: string | null;
    version?: string;
    value: string;
    description?: string | null;
    list_name?: ItemModel.list_name;
    code?: string | null;
    readonly created_by?: string;
    last_modified_by?: string | null;
};

export namespace ItemModel {

    export enum list_name {
        TICKET_STATUS = 'TICKET_STATUS',
        COVERAGE_TYPE = 'COVERAGE_TYPE',
        GSX_SERVICE_TYPE = 'GSX_SERVICE_TYPE',
        REPAIR_TYPE = 'REPAIR_TYPE',
        GSX_REPAIR_TYPE = 'GSX_REPAIR_TYPE',
        CUSTOMER_TYPE = 'CUSTOMER_TYPE',
        UNIT_PART = 'UNIT_PART',
        STATES = 'STATES',
        COUNTRY = 'COUNTRY',
        SERIALIZABLE_INVENTORY_ITEM = 'SERIALIZABLE_INVENTORY_ITEM',
        LOANER_INVENTORY_PART_NUMBERS = 'LOANER_INVENTORY_PART_NUMBERS',
        LOANER_INVENTORY_PENALTY_REASONS = 'LOANER_INVENTORY_PENALTY_REASONS',
        CONSIGNMENT_TYPE = 'CONSIGNMENT_TYPE',
        REPORT_TYPES = 'REPORT_TYPES',
        UPLOAD_DOCUMENT_TYPES = 'UPLOAD_DOCUMENT_TYPES',
        REPAIR_INVENTORY_ITEMS = 'REPAIR_INVENTORY_ITEMS',
    }


}
